import keyMirror from 'src/utilities/keyMirror';

const PREFIX = 'API_OFFLINE';

export const ACTION_TYPES = keyMirror({
  // Cash out types
  [`${PREFIX}_LOAD_CASHOUT_LIST`]: null,
  [`${PREFIX}_LOAD_CASHOUT_LIST_SUCCESS`]: null,
  [`${PREFIX}_LOAD_CASHOUT_LIST_FAILED`]: null,

  // Cash in types
  [`${PREFIX}_LOAD_CASHIN_LIST`]: null,
  [`${PREFIX}_LOAD_CASHIN_LIST_SUCCESS`]: null,
  [`${PREFIX}_LOAD_CASHIN_LIST_FAILED`]: null,
});
